import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { ScheduleAiOffDialogComponent } from './schedule-ai-off-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: 'root',
})
export class ScheduleAiOffDialogService {
  constructor(private dialog: DialogService) {}

  open(data?: { date: number; timezone?: string }) {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      data,
    }

    return this.dialog.openVariableDialog(ScheduleAiOffDialogComponent, defaultConfig)
  }
}
